export const LINKS_NAVIGATION = {
  Intro: "/$sessionId/intro",
  Address: "/$sessionId/address",
  Wall: "/$sessionId/wall",
  UtilityRoom: "/$sessionId/utilityRoom",
  ExtraEquipment: "/$sessionId/extraEquipment",
  Overview: "/$sessionId/overview",
  Finished: "/$sessionId/finished",
} as const
